"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _InlineWysiwyg = _interopRequireDefault(require("./InlineWysiwyg"));
var _SectionTitle = _interopRequireDefault(require("./SectionTitle"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var IconAndDescription = function IconAndDescription(props) {
  var heading = props.heading,
    name = props.name,
    formProps = props.formProps,
    DefaultIcon = props.DefaultIcon;
  var setImageDetails = function setImageDetails(img) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, _defineProperty({}, name, _objectSpread(_objectSpread({}, formProps.values.courseDescription[name]), {}, {
        imageDetails: img
      })))
    }));
  };
  var _formProps$values$cou = formProps.values.courseDescription[name],
    iconSelection = _formProps$values$cou.icon,
    iconColor = _formProps$values$cou.iconColor,
    imageDetails = _formProps$values$cou.imageDetails;
  var validateImageDimensions = function validateImageDimensions() {
    if (!imageDetails || !imageDetails.metadata) {
      return;
    }
    // Image will be a centered, cover background with
    // width of 30px and height of 30px (), so this
    // checks that it will not be cropped undexpectedly
    var _imageDetails$metadat = imageDetails.metadata,
      width = _imageDetails$metadat.width,
      height = _imageDetails$metadat.height;
    var ratio = width / height;
    return ratio < 1.05 && ratio > 0.95;
  };
  var getTitlePlaceholder = function getTitlePlaceholder() {
    if (name === 'audience') return 'Audience';
    if (name === 'creditHours') return 'Credit Hours';
    if (name === 'duration') return 'Duration';
    return name;
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, heading), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: name,
    placeholder: getTitlePlaceholder()
  }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
    name: "courseDescription.".concat(name, ".description"),
    label: "Description"
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label",
    htmlFor: "courseDescription.".concat(name, ".icon")
  }, "Icon"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].iconAndDescriptionRadio, " mb-3")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].iconRadioGroup
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "courseDescription.".concat(name, ".icon"),
    value: "default",
    checked: iconSelection === 'default'
  }), ' ', "Default icon")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "courseDescription.".concat(name, ".icon"),
    value: "none",
    checked: iconSelection === 'none'
  }), ' ', "No icon")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "courseDescription.".concat(name, ".icon"),
    value: "upload",
    checked: iconSelection === 'upload'
  }), ' ', "Upload icon"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].iconContainer
  }, iconSelection === 'default' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: (0, _cccisdColorPicker.getColor)(iconColor)
    }
  }, /*#__PURE__*/_react["default"].createElement(DefaultIcon, null)), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "courseDescription.".concat(name, ".iconColor"),
    component: _cccisdFormik.CccisdColorPicker
  })), iconSelection === 'upload' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, imageDetails && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].bgImage,
    style: {
      backgroundImage: "url(\"".concat(imageDetails.url, "\")")
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
    onChange: setImageDetails,
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-secondary"
    }, imageDetails ? 'Change icon' : 'Select icon')
  })))), imageDetails && !validateImageDimensions() && /*#__PURE__*/_react["default"].createElement("p", {
    className: "bg-warning"
  }, /*#__PURE__*/_react["default"].createElement("small", null, "Note: Ideal image dimensions are 60px (w) by 60px (h). Please verify thumbnail.")));
};
var _default = exports["default"] = IconAndDescription;